<template>
  <div id="app">
    <template v-if="currentUser.user_info !== null">
      <div class="wrapper">
        <va-navibar></va-navibar>
        <va-slider></va-slider>
        <router-view></router-view>
        <va-footer></va-footer>
      </div>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import NaviBar from './components/NaviBar.vue'
import Slider from './components/Slider.vue'
import VAFooter from './components/VAFooter.vue'
import store from './vuex/store.js'
import {mapGetters} from 'vuex'
import ity, { initITY } from './lib/ity'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    ua () {
      return ity.ua
    },
  },
  data () {
    return {
      intervalId: undefined,
    }
  },
  mounted () {
    if (this.currentUser &&
      this.currentUser.user_info &&
      this.currentUser.user_info.call_center &&
      this.currentUser.user_info.call_center.ext &&
      this.currentUser.user_info.call_center.secret &&
      this.currentUser.user_info.call_center.sip_server) {
      initITY({
        userName: this.currentUser.user_info.call_center.ext,
        password: this.currentUser.user_info.call_center.secret,
        server: this.currentUser.user_info.call_center.sip_server,
        tenant: this.currentUser.user_info.call_center.tenant,
        handleDisconnect: this.onDisconnect
      })
    }
    this.register()
  },
  components: {
    'va-navibar': NaviBar,
    'va-footer': VAFooter,
    'va-slider': Slider
  },
  methods: {
    async onDisconnect () {
      console.log('SIP is disconnected, reconnecting...')
      await this.register()
      this.intervalId = setInterval(() => {
        this.register()
      }, 100000)
    },
    async register () {
      try {
        await this.ua.connect()
        await this.ua.registerAgent()
        if (this.intervalId !== undefined) {
          clearInterval(this.intervalId)
          this.intervalId = undefined
        }
      } catch (e) {
        console.log('connect error', e)
      }
    },
  },
  store
}
</script>

<style lang="scss">
@import 'assets/scss/style';

#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue